export default __webpack_public_path__ + "static/media/chevron-down.595aae68.svg";